<template>
  <div v-if="product?.upsell">
    <!-- this element must have a root div, because it was not being reactive to the v-model -->
    <product-upsells
      v-model="cart.selectedUpsells"
      class="space-y-4 mb-10"
      data-test-id="product-upsell"
      :is-carousel="$feature.showUpsellCarouselOnPDP && product.upsell?.length > 1"
      :show-button="upsells?.showButton"
      :show-checkbox="upsells?.showCheckbox"
      :show-details="upsells?.showDetails"
      :show-modal="$feature.showUpsellModal"
      :upsells="product.upsell"
      @open-quickshop="openQuickshop($event, gtmConfig)"
    />
  </div>
</template>

<script setup lang="ts">
import type { InteractionOrigin, ProductContext } from '#types/gtm'

const { upsells } = useAppConfig().pages?.pdp
const cart = useCartStore()
const { openQuickshop, product } = usePdp()

const gtmConfig: ProductContext & { appSource?: InteractionOrigin } = {
  appSource: 'up-sell-complete-the-look',
  category: 'UpSellCompleteTheLook',
  list: 'UpSellCompleteTheLook'
}
</script>
